import { apiAxiosAuth } from 'services/api';
import { UserMondelezProps } from 'types/UserProps';
import { FiltersUsersProps } from 'types/FiltersUsersProps';

function roundNumber(totalUsers: number, qtdPerPAge: number) {
	const total = Math.ceil(totalUsers / qtdPerPAge);
	return total;
}

export async function getUsers(
	filters: FiltersUsersProps,
	page: number,
	setListUsers: React.Dispatch<React.SetStateAction<UserMondelezProps[]>>,
	setQtdPages: React.Dispatch<React.SetStateAction<number>>,
	handleNotify: any
) {
	const email =
		filters.filterByEmail === '' ? '' : `email=${filters.filterByEmail}`;
	const cpf = filters.filterByCpf === '' ? '' : `cpf=${filters.filterByCpf}`;
	const justUsersAllowed = `role=${filters.justUsersAllowed}`;

	let url = 'users?';

	if (email !== '') {
		url = `${url}${email}`;
	}
	if (cpf !== '') {
		url = `${url}${email !== '' ? '&' : ''}${cpf}`;
	}

	url = `${url}${email !== '' || cpf !== '' ? '&' : ''}&size=10&page=${page}&${justUsersAllowed}`;

	await apiAxiosAuth
		.get(url)
		.then((res) => {
			setQtdPages(1);
			setListUsers(res?.data?.data || []);
			setQtdPages(
				roundNumber(
					parseInt(res?.data?.total || '0'),
					parseInt(res?.data?.data?.total || '10')
				)
			);
		})
		.catch((error) => {
			handleNotify(
				error?.response?.data?.message[0] || 'Erro ao buscar os usuários',
				'error'
			);
		});
}
